export default "__VITE_ASSET__DhaSuJIr__"